import type { WordPackDefinition } from "./types";

// Nature pack - animals, plants, weather, ecosystems
export const NATURE_WORDS = [
  // Mammals
  "WOLF", "FOX", "DEER", "MOOSE", "ELK", "BISON", "BOAR", "BADGER", "OTTER", "BEAVER",
  "SQUIRREL", "HEDGEHOG", "PORCUPINE", "SKUNK", "RACCOON", "OPOSSUM", "ARMADILLO", "SLOTH", "ANTEATER", "PANGOLIN",
  "GORILLA", "CHIMPANZEE", "ORANGUTAN", "BABOON", "LEMUR", "KOALA", "WOMBAT", "TASMANIAN", "JAGUAR", "LEOPARD",
  "CHEETAH", "PANTHER", "COUGAR", "LYNX", "BOBCAT", "HYENA", "JACKAL", "COYOTE", "DINGO", "FENNEC",
  // Birds
  "FALCON", "OSPREY", "CONDOR", "VULTURE", "RAVEN", "CROW", "MAGPIE", "JAY", "CARDINAL", "BLUEBIRD",
  "SPARROW", "FINCH", "WARBLER", "THRUSH", "WREN", "SWALLOW", "SWIFT", "HUMMINGBIRD", "KINGFISHER", "WOODPECKER",
  "PELICAN", "HERON", "CRANE", "STORK", "IBIS", "FLAMINGO", "SWAN", "GOOSE", "MALLARD", "PUFFIN",
  "PARROT", "TOUCAN", "MACAW", "COCKATOO", "PEACOCK", "PHEASANT", "QUAIL", "GROUSE", "TURKEY", "OSTRICH",
  // Reptiles & Amphibians
  "CROCODILE", "ALLIGATOR", "IGUANA", "GECKO", "CHAMELEON", "KOMODO", "MONITOR", "COBRA", "PYTHON", "VIPER",
  "RATTLESNAKE", "ANACONDA", "BOA", "TORTOISE", "TURTLE", "TERRAPIN", "NEWT", "SALAMANDER", "AXOLOTL", "TOAD",
  // Sea Life
  "DOLPHIN", "ORCA", "PORPOISE", "MANATEE", "WALRUS", "SEA LION", "DUGONG", "NARWHAL", "BELUGA", "HUMPBACK",
  "MANTA", "STINGRAY", "BARRACUDA", "SWORDFISH", "MARLIN", "TUNA", "SALMON", "TROUT", "BASS", "CARP",
  "JELLYFISH", "STARFISH", "SEA URCHIN", "SEAHORSE", "CORAL", "ANEMONE", "CLAM", "OYSTER", "MUSSEL", "CRAB",
  "LOBSTER", "SHRIMP", "SQUID", "NAUTILUS", "URCHIN", "BARNACLE", "KELP", "SEAWEED", "PLANKTON", "KRILL",
  // Insects & Arachnids
  "BUTTERFLY", "MOTH", "DRAGONFLY", "DAMSELFLY", "BEETLE", "LADYBUG", "FIREFLY", "GRASSHOPPER", "CRICKET", "CICADA",
  "ANT", "TERMITE", "BEE", "WASP", "HORNET", "FLY", "MOSQUITO", "FLEA", "TICK", "MITE",
  "TARANTULA", "SCORPION", "CENTIPEDE", "MILLIPEDE", "MANTIS", "STICK INSECT", "CATERPILLAR", "MAGGOT", "LARVA", "COCOON",
  // Plants & Trees
  "OAK", "PINE", "CEDAR", "REDWOOD", "SEQUOIA", "BIRCH", "WILLOW", "ASH", "ELM", "BEECH",
  "BAMBOO", "PALM", "CACTUS", "FERN", "MOSS", "LICHEN", "IVY", "VINE", "SHRUB", "BUSH",
  "ORCHID", "LILY", "TULIP", "DAISY", "SUNFLOWER", "LOTUS", "IRIS", "VIOLET", "JASMINE", "LAVENDER",
  // Weather & Elements
  "STORM", "THUNDER", "LIGHTNING", "TORNADO", "HURRICANE", "CYCLONE", "TYPHOON", "MONSOON", "BLIZZARD", "AVALANCHE",
  "FLOOD", "DROUGHT", "HEATWAVE", "FROST", "DEW", "FOG", "MIST", "HAZE", "RAINBOW", "AURORA",
  "BREEZE", "GUST", "GALE", "SQUALL", "HAIL", "SLEET", "ICICLE", "SNOWFLAKE", "RAINDROP", "PUDDLE",
  // Ecosystems & Habitats
  "JUNGLE", "SWAMP", "WETLAND", "MANGROVE", "CORAL REEF", "TIDE POOL", "CAVE", "CAVERN", "GROTTO", "RAVINE",
  "MEADOW", "PASTURE", "ORCHARD", "GROVE", "THICKET", "CLEARING", "UNDERGROWTH", "CANOPY", "UNDERSTORY", "ROOT",
];

export const NATURE_SEMANTIC_FAMILIES: string[][] = [
  ["WOLF", "FOX", "DEER", "MOOSE", "ELK", "BISON", "BOAR", "BADGER"],
  ["GORILLA", "CHIMPANZEE", "ORANGUTAN", "BABOON", "LEMUR", "KOALA", "WOMBAT"],
  ["FALCON", "OSPREY", "CONDOR", "VULTURE", "RAVEN", "CROW", "SPARROW", "FINCH", "SWALLOW", "HUMMINGBIRD"],
  ["CROCODILE", "ALLIGATOR", "IGUANA", "GECKO", "CHAMELEON", "COBRA", "PYTHON", "VIPER", "ANACONDA", "BOA"],
  ["DOLPHIN", "ORCA", "MANATEE", "NARWHAL", "BELUGA", "HUMPBACK", "MANTA", "STINGRAY", "BARRACUDA", "TUNA"],
  ["JELLYFISH", "STARFISH", "SEAHORSE", "CORAL", "ANEMONE", "CLAM", "OYSTER", "MUSSEL", "CRAB", "LOBSTER", "SQUID", "NAUTILUS"],
  ["BUTTERFLY", "MOTH", "DRAGONFLY", "BEETLE", "LADYBUG", "ANT", "BEE", "WASP", "HORNET", "MOSQUITO", "SCORPION"],
  ["OAK", "PINE", "CEDAR", "REDWOOD", "SEQUOIA", "BIRCH", "WILLOW", "ELM", "BEECH", "BAMBOO", "PALM", "CACTUS", "FERN", "MOSS", "VINE"],
  ["ORCHID", "LILY", "TULIP", "DAISY", "SUNFLOWER", "LOTUS", "IRIS", "VIOLET", "JASMINE", "LAVENDER"],
  ["STORM", "THUNDER", "LIGHTNING", "TORNADO", "HURRICANE", "BLIZZARD", "FROST", "FOG", "RAINBOW", "AURORA", "BREEZE", "GALE", "HAIL", "SLEET"],
  ["JUNGLE", "SWAMP", "WETLAND", "MANGROVE", "CORAL REEF", "TIDE POOL", "CAVE", "CAVERN", "RAVINE", "MEADOW", "PASTURE", "ORCHARD", "GROVE", "CANOPY", "UNDERSTORY"],
];

export const NATURE_PACK: WordPackDefinition = {
  key: "nature",
  words: NATURE_WORDS,
  semanticFamilies: NATURE_SEMANTIC_FAMILIES,
};
